/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { ComplianceFormPartBGeneralTrustMoneyRequest } from '../models';
import { ComplianceFormPartBRequest } from '../models';
import { FormPracticeAccountQuestionResponse } from '../models';
import { PartBFormControlledMoneyRequest } from '../models';
import { PartBFormControlledMoneyResponse } from '../models';
import { PartBFormDeclarationRequest } from '../models';
import { PartBFormDeclarationResponse } from '../models';
import { PartBFormGeneralTrustMoneyRequest } from '../models';
import { PartBFormGeneralTrustMoneyResponse } from '../models';
import { PartBFormInvestmentMoneyRequest } from '../models';
import { PartBFormInvestmentMoneyResponse } from '../models';
import { PartBFormOtherInformationRequest } from '../models';
import { PartBFormOtherInformationResponse } from '../models';
import { PartBFormOverviewResponse } from '../models';
import { PartBFormPracticeAccountRequest } from '../models';
import { PartBFormSpecificPowerMoneyRequest } from '../models';
import { PartBFormSpecificPowerMoneyResponse } from '../models';
import { PartBFormStatusResponse } from '../models';
import { PartBFormSubmitRequest } from '../models';
import { PartBFormTrustAccountingRecordsRequest } from '../models';
import { PartBFormTrustAccountingRecordsResponse } from '../models';
import { PartBResubmissionRequestRequest } from '../models';
/**
 * PartBFormApi - axios parameter creator
 * @export
 */
export const PartBFormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form Practice Account Questions
         * @param {PartBFormPracticeAccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormAddFormPracticeAccountPost: async (body?: PartBFormPracticeAccountRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/AddFormPracticeAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Save PartB Resubmission Request
         * @param {PartBResubmissionRequestRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormAdminSavePartBResubmissionRequestPost: async (body?: PartBResubmissionRequestRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/Admin/SavePartBResubmissionRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns true when a form is successfully closed
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormClosePost: async (body?: ComplianceFormPartBRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/Close`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Extend the current Form Status
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormExtendFormStatusPost: async (body?: ComplianceFormPartBRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/ExtendFormStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Controlled Money
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetControlledMoneyPost: async (body?: ComplianceFormPartBRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/GetControlledMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Overview
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetDeclarationPost: async (body?: ComplianceFormPartBRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/GetDeclaration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Returns Part B Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetFormStatusComplianceFormIdGet: async (complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2PartBFormGetFormStatusComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/PartBForm/GetFormStatus/{complianceFormId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - General Trust Money
         * @param {ComplianceFormPartBGeneralTrustMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetGeneralTrustMoneyPost: async (body?: ComplianceFormPartBGeneralTrustMoneyRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/GetGeneralTrustMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Investment Money
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetInvestmentMoneyPost: async (body?: ComplianceFormPartBRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/GetInvestmentMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Other Information
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetOtherInformationPost: async (body?: ComplianceFormPartBRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/GetOtherInformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Overview
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetOverviewPost: async (body?: ComplianceFormPartBRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/GetOverview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Specific PowerMoney
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetSpecificPowerMoneyPost: async (body?: ComplianceFormPartBRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/GetSpecificPowerMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - TrustAccountingRecords
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetTrustAccountingRecordsPost: async (body?: ComplianceFormPartBRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/GetTrustAccountingRecords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Kick out the current Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormKickOutFormStatusComplianceFormIdGet: async (complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2PartBFormKickOutFormStatusComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/PartBForm/KickOutFormStatus/{complianceFormId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Controlled Money Responses
         * @param {PartBFormControlledMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveControlledMoneyPost: async (body?: PartBFormControlledMoneyRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/SaveControlledMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal | Save Part B Form Declaration
         * @param {PartBFormDeclarationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveDeclarationPost: async (body?: PartBFormDeclarationRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/SaveDeclaration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form Practice Account Questions
         * @param {PartBFormPracticeAccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveFormPracticeAccountPost: async (body?: PartBFormPracticeAccountRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/SaveFormPracticeAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - General Trust Money Responses
         * @param {PartBFormGeneralTrustMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveGeneralTrustMoneyPost: async (body?: PartBFormGeneralTrustMoneyRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/SaveGeneralTrustMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Investment Money Responses
         * @param {PartBFormInvestmentMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveInvestmentMoneyPost: async (body?: PartBFormInvestmentMoneyRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/SaveInvestmentMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Specific Other Information Responses
         * @param {PartBFormOtherInformationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveOtherInformationPost: async (body?: PartBFormOtherInformationRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/SaveOtherInformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Specific Power Money Responses
         * @param {PartBFormSpecificPowerMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveSpecificPowerMoneyPost: async (body?: PartBFormSpecificPowerMoneyRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/SaveSpecificPowerMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Trust Accounting Records Responses
         * @param {PartBFormTrustAccountingRecordsRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveTrustAccountingRecordsPost: async (body?: PartBFormTrustAccountingRecordsRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/SaveTrustAccountingRecords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal | Submit Part B Form
         * @param {PartBFormSubmitRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSubmitFormPost: async (body?: PartBFormSubmitRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/SubmitForm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Update Part B Form Practice Account
         * @param {PartBFormPracticeAccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormUpdateFormPracticeAccountPost: async (body?: PartBFormPracticeAccountRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartBForm/UpdateFormPracticeAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartBFormApi - functional programming interface
 * @export
 */
export const PartBFormApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form Practice Account Questions
         * @param {PartBFormPracticeAccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormAddFormPracticeAccountPost(body?: PartBFormPracticeAccountRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormAddFormPracticeAccountPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Save PartB Resubmission Request
         * @param {PartBResubmissionRequestRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormAdminSavePartBResubmissionRequestPost(body?: PartBResubmissionRequestRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormAdminSavePartBResubmissionRequestPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns true when a form is successfully closed
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormClosePost(body?: ComplianceFormPartBRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormClosePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Extend the current Form Status
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormExtendFormStatusPost(body?: ComplianceFormPartBRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormExtendFormStatusPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Controlled Money
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormGetControlledMoneyPost(body?: ComplianceFormPartBRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartBFormControlledMoneyResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormGetControlledMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Overview
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormGetDeclarationPost(body?: ComplianceFormPartBRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartBFormDeclarationResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormGetDeclarationPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Returns Part B Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormGetFormStatusComplianceFormIdGet(complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartBFormStatusResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormGetFormStatusComplianceFormIdGet(complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - General Trust Money
         * @param {ComplianceFormPartBGeneralTrustMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormGetGeneralTrustMoneyPost(body?: ComplianceFormPartBGeneralTrustMoneyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartBFormGeneralTrustMoneyResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormGetGeneralTrustMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Investment Money
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormGetInvestmentMoneyPost(body?: ComplianceFormPartBRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartBFormInvestmentMoneyResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormGetInvestmentMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Other Information
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormGetOtherInformationPost(body?: ComplianceFormPartBRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartBFormOtherInformationResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormGetOtherInformationPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Overview
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormGetOverviewPost(body?: ComplianceFormPartBRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartBFormOverviewResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormGetOverviewPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Specific PowerMoney
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormGetSpecificPowerMoneyPost(body?: ComplianceFormPartBRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartBFormSpecificPowerMoneyResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormGetSpecificPowerMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - TrustAccountingRecords
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormGetTrustAccountingRecordsPost(body?: ComplianceFormPartBRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartBFormTrustAccountingRecordsResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormGetTrustAccountingRecordsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Kick out the current Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormKickOutFormStatusComplianceFormIdGet(complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormKickOutFormStatusComplianceFormIdGet(complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Controlled Money Responses
         * @param {PartBFormControlledMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormSaveControlledMoneyPost(body?: PartBFormControlledMoneyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormSaveControlledMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal | Save Part B Form Declaration
         * @param {PartBFormDeclarationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormSaveDeclarationPost(body?: PartBFormDeclarationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormSaveDeclarationPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form Practice Account Questions
         * @param {PartBFormPracticeAccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormSaveFormPracticeAccountPost(body?: PartBFormPracticeAccountRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormPracticeAccountQuestionResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormSaveFormPracticeAccountPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - General Trust Money Responses
         * @param {PartBFormGeneralTrustMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormSaveGeneralTrustMoneyPost(body?: PartBFormGeneralTrustMoneyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormSaveGeneralTrustMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Investment Money Responses
         * @param {PartBFormInvestmentMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormSaveInvestmentMoneyPost(body?: PartBFormInvestmentMoneyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormSaveInvestmentMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Specific Other Information Responses
         * @param {PartBFormOtherInformationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormSaveOtherInformationPost(body?: PartBFormOtherInformationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormSaveOtherInformationPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Specific Power Money Responses
         * @param {PartBFormSpecificPowerMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormSaveSpecificPowerMoneyPost(body?: PartBFormSpecificPowerMoneyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormSaveSpecificPowerMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Trust Accounting Records Responses
         * @param {PartBFormTrustAccountingRecordsRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormSaveTrustAccountingRecordsPost(body?: PartBFormTrustAccountingRecordsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormSaveTrustAccountingRecordsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal | Submit Part B Form
         * @param {PartBFormSubmitRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormSubmitFormPost(body?: PartBFormSubmitRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormSubmitFormPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Update Part B Form Practice Account
         * @param {PartBFormPracticeAccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartBFormUpdateFormPracticeAccountPost(body?: PartBFormPracticeAccountRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartBFormApiAxiosParamCreator(configuration).apiV2PartBFormUpdateFormPracticeAccountPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PartBFormApi - factory interface
 * @export
 */
export const PartBFormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form Practice Account Questions
         * @param {PartBFormPracticeAccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormAddFormPracticeAccountPost(body?: PartBFormPracticeAccountRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormAddFormPracticeAccountPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Save PartB Resubmission Request
         * @param {PartBResubmissionRequestRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormAdminSavePartBResubmissionRequestPost(body?: PartBResubmissionRequestRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormAdminSavePartBResubmissionRequestPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns true when a form is successfully closed
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormClosePost(body?: ComplianceFormPartBRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormClosePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Extend the current Form Status
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormExtendFormStatusPost(body?: ComplianceFormPartBRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormExtendFormStatusPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Controlled Money
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetControlledMoneyPost(body?: ComplianceFormPartBRequest, options?: any): AxiosPromise<PartBFormControlledMoneyResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormGetControlledMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Overview
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetDeclarationPost(body?: ComplianceFormPartBRequest, options?: any): AxiosPromise<PartBFormDeclarationResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormGetDeclarationPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Returns Part B Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetFormStatusComplianceFormIdGet(complianceFormId: number, options?: any): AxiosPromise<PartBFormStatusResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormGetFormStatusComplianceFormIdGet(complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - General Trust Money
         * @param {ComplianceFormPartBGeneralTrustMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetGeneralTrustMoneyPost(body?: ComplianceFormPartBGeneralTrustMoneyRequest, options?: any): AxiosPromise<PartBFormGeneralTrustMoneyResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormGetGeneralTrustMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Investment Money
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetInvestmentMoneyPost(body?: ComplianceFormPartBRequest, options?: any): AxiosPromise<PartBFormInvestmentMoneyResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormGetInvestmentMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Other Information
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetOtherInformationPost(body?: ComplianceFormPartBRequest, options?: any): AxiosPromise<PartBFormOtherInformationResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormGetOtherInformationPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Overview
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetOverviewPost(body?: ComplianceFormPartBRequest, options?: any): AxiosPromise<PartBFormOverviewResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormGetOverviewPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Specific PowerMoney
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetSpecificPowerMoneyPost(body?: ComplianceFormPartBRequest, options?: any): AxiosPromise<PartBFormSpecificPowerMoneyResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormGetSpecificPowerMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - TrustAccountingRecords
         * @param {ComplianceFormPartBRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormGetTrustAccountingRecordsPost(body?: ComplianceFormPartBRequest, options?: any): AxiosPromise<PartBFormTrustAccountingRecordsResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormGetTrustAccountingRecordsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Kick out the current Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormKickOutFormStatusComplianceFormIdGet(complianceFormId: number, options?: any): AxiosPromise<BooleanResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormKickOutFormStatusComplianceFormIdGet(complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Controlled Money Responses
         * @param {PartBFormControlledMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveControlledMoneyPost(body?: PartBFormControlledMoneyRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormSaveControlledMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal | Save Part B Form Declaration
         * @param {PartBFormDeclarationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveDeclarationPost(body?: PartBFormDeclarationRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormSaveDeclarationPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form Practice Account Questions
         * @param {PartBFormPracticeAccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveFormPracticeAccountPost(body?: PartBFormPracticeAccountRequest, options?: any): AxiosPromise<FormPracticeAccountQuestionResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormSaveFormPracticeAccountPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - General Trust Money Responses
         * @param {PartBFormGeneralTrustMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveGeneralTrustMoneyPost(body?: PartBFormGeneralTrustMoneyRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormSaveGeneralTrustMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Investment Money Responses
         * @param {PartBFormInvestmentMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveInvestmentMoneyPost(body?: PartBFormInvestmentMoneyRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormSaveInvestmentMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Specific Other Information Responses
         * @param {PartBFormOtherInformationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveOtherInformationPost(body?: PartBFormOtherInformationRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormSaveOtherInformationPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Specific Power Money Responses
         * @param {PartBFormSpecificPowerMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveSpecificPowerMoneyPost(body?: PartBFormSpecificPowerMoneyRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormSaveSpecificPowerMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Trust Accounting Records Responses
         * @param {PartBFormTrustAccountingRecordsRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSaveTrustAccountingRecordsPost(body?: PartBFormTrustAccountingRecordsRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormSaveTrustAccountingRecordsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal | Submit Part B Form
         * @param {PartBFormSubmitRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormSubmitFormPost(body?: PartBFormSubmitRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormSubmitFormPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Update Part B Form Practice Account
         * @param {PartBFormPracticeAccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartBFormUpdateFormPracticeAccountPost(body?: PartBFormPracticeAccountRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartBFormApiFp(configuration).apiV2PartBFormUpdateFormPracticeAccountPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartBFormApi - object-oriented interface
 * @export
 * @class PartBFormApi
 * @extends {BaseAPI}
 */
export class PartBFormApi extends BaseAPI {
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form Practice Account Questions
     * @param {PartBFormPracticeAccountRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormAddFormPracticeAccountPost(body?: PartBFormPracticeAccountRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormAddFormPracticeAccountPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Save PartB Resubmission Request
     * @param {PartBResubmissionRequestRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormAdminSavePartBResubmissionRequestPost(body?: PartBResubmissionRequestRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormAdminSavePartBResubmissionRequestPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Returns true when a form is successfully closed
     * @param {ComplianceFormPartBRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormClosePost(body?: ComplianceFormPartBRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormClosePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact  | Extend the current Form Status
     * @param {ComplianceFormPartBRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormExtendFormStatusPost(body?: ComplianceFormPartBRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormExtendFormStatusPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Controlled Money
     * @param {ComplianceFormPartBRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormGetControlledMoneyPost(body?: ComplianceFormPartBRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormGetControlledMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Overview
     * @param {ComplianceFormPartBRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormGetDeclarationPost(body?: ComplianceFormPartBRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormGetDeclarationPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact  | Returns Part B Form Status
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormGetFormStatusComplianceFormIdGet(complianceFormId: number, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormGetFormStatusComplianceFormIdGet(complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - General Trust Money
     * @param {ComplianceFormPartBGeneralTrustMoneyRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormGetGeneralTrustMoneyPost(body?: ComplianceFormPartBGeneralTrustMoneyRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormGetGeneralTrustMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Investment Money
     * @param {ComplianceFormPartBRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormGetInvestmentMoneyPost(body?: ComplianceFormPartBRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormGetInvestmentMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Other Information
     * @param {ComplianceFormPartBRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormGetOtherInformationPost(body?: ComplianceFormPartBRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormGetOtherInformationPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Overview
     * @param {ComplianceFormPartBRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormGetOverviewPost(body?: ComplianceFormPartBRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormGetOverviewPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - Get Specific PowerMoney
     * @param {ComplianceFormPartBRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormGetSpecificPowerMoneyPost(body?: ComplianceFormPartBRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormGetSpecificPowerMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Returns Part B Form - TrustAccountingRecords
     * @param {ComplianceFormPartBRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormGetTrustAccountingRecordsPost(body?: ComplianceFormPartBRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormGetTrustAccountingRecordsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact  | Kick out the current Form Status
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormKickOutFormStatusComplianceFormIdGet(complianceFormId: number, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormKickOutFormStatusComplianceFormIdGet(complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Controlled Money Responses
     * @param {PartBFormControlledMoneyRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormSaveControlledMoneyPost(body?: PartBFormControlledMoneyRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormSaveControlledMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal | Save Part B Form Declaration
     * @param {PartBFormDeclarationRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormSaveDeclarationPost(body?: PartBFormDeclarationRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormSaveDeclarationPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form Practice Account Questions
     * @param {PartBFormPracticeAccountRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormSaveFormPracticeAccountPost(body?: PartBFormPracticeAccountRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormSaveFormPracticeAccountPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - General Trust Money Responses
     * @param {PartBFormGeneralTrustMoneyRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormSaveGeneralTrustMoneyPost(body?: PartBFormGeneralTrustMoneyRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormSaveGeneralTrustMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Investment Money Responses
     * @param {PartBFormInvestmentMoneyRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormSaveInvestmentMoneyPost(body?: PartBFormInvestmentMoneyRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormSaveInvestmentMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Specific Other Information Responses
     * @param {PartBFormOtherInformationRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormSaveOtherInformationPost(body?: PartBFormOtherInformationRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormSaveOtherInformationPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Specific Power Money Responses
     * @param {PartBFormSpecificPowerMoneyRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormSaveSpecificPowerMoneyPost(body?: PartBFormSpecificPowerMoneyRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormSaveSpecificPowerMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Save Part B Form - Trust Accounting Records Responses
     * @param {PartBFormTrustAccountingRecordsRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormSaveTrustAccountingRecordsPost(body?: PartBFormTrustAccountingRecordsRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormSaveTrustAccountingRecordsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal | Submit Part B Form
     * @param {PartBFormSubmitRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormSubmitFormPost(body?: PartBFormSubmitRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormSubmitFormPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Update Part B Form Practice Account
     * @param {PartBFormPracticeAccountRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartBFormApi
     */
    public apiV2PartBFormUpdateFormPracticeAccountPost(body?: PartBFormPracticeAccountRequest, options?: any) {
        return PartBFormApiFp(this.configuration).apiV2PartBFormUpdateFormPracticeAccountPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
